"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPriceDropAlertsListResponseDto = instanceOfPriceDropAlertsListResponseDto;
exports.PriceDropAlertsListResponseDtoFromJSON = PriceDropAlertsListResponseDtoFromJSON;
exports.PriceDropAlertsListResponseDtoFromJSONTyped = PriceDropAlertsListResponseDtoFromJSONTyped;
exports.PriceDropAlertsListResponseDtoToJSON = PriceDropAlertsListResponseDtoToJSON;
exports.PriceDropAlertsListResponseDtoToJSONTyped = PriceDropAlertsListResponseDtoToJSONTyped;
var PriceDropAlertListItemDto_1 = require("./PriceDropAlertListItemDto");
/**
 * Check if a given object implements the PriceDropAlertsListResponseDto interface.
 */
function instanceOfPriceDropAlertsListResponseDto(value) {
    if (!('alerts' in value) || value['alerts'] === undefined)
        return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    return true;
}
function PriceDropAlertsListResponseDtoFromJSON(json) {
    return PriceDropAlertsListResponseDtoFromJSONTyped(json, false);
}
function PriceDropAlertsListResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alerts': (json['alerts'].map(PriceDropAlertListItemDto_1.PriceDropAlertListItemDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}
function PriceDropAlertsListResponseDtoToJSON(json) {
    return PriceDropAlertsListResponseDtoToJSONTyped(json, false);
}
function PriceDropAlertsListResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'alerts': (value['alerts'].map(PriceDropAlertListItemDto_1.PriceDropAlertListItemDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}
